import HttpService from "@/utils/httpData"

export const listLessonClassSchoolUserService = params => {
    let apiEndpoint = `LessonClassSchoolUser/List`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListExcerciseTecherManager = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetListExcerciseTecherManager`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListUserExcerice = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetListUserExcerice`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListUserElectroniclecture = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetListUserElectroniclecture`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListUserLessonPlaning = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetListUserLessonPlaning`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getQuestionExcerciseRateFalse = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetQuestionExcerciseRateFalse`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getQuestionLessonPlaningRateFalse = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetQuestionLessonPlaningRateFalse`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListClassSchoolMemberPersonal = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetProfileUserClass`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListExcerice = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetListExcerice`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const getListElectroniclecture = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetListElectroniclecture`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}


export const getListLessonPlaning = params => {
    let apiEndpoint = `LessonClassSchoolUser/GetListLessonPlaning`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}